import { TNullableFloat, IErrorObject } from 'store/deal-evaluation/types';
import { IPortfolioWithDetails } from 'store/portfolio/types';
import { EModalTitle } from 'lib/storage';

export enum EParetoActionType {
  RESET = 'RESET',
  SET_PARETO_DEAL_IDS = 'SET_PARETO_DEAL_IDS',
  SET_PARETO_DEALS = 'SET_PARETO_DEALS',
  SET_DEAL_FILTER = 'SET_DEAL_FILTER',
  SET_REGION_FILTER = 'SET_REGION_FILTER',
  SET_PRODUCT_LINE_FILTER = 'SET_PRODUCT_LINE_FILTER',
  SET_SEARCH_KEYWORD = 'SET_SEARCH_KEYWORD',
  SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN',
  SET_BAR_WIDTH = 'SET_BAR_WIDTH',
  SET_PORTFOLIO_DEAL_IDS = 'SET_PORTFOLIO_DEAL_IDS',
  SET_PORTFOLIO_DEALS = 'SET_PORTFOLIO_DEALS',
}

export interface IParetoState {
  paretoDealIds: string[];
  paretoDeals: IParetoDeal[];
  dealFilter: EParetoDealFilter;
  regionFilter: string;
  productLineFilter: string;
  searchKeyword: string;
  isModalOpen: boolean;
  hasVolumeWidthBars: boolean;
  portfolioDealIds: string[];
  portfolioDeals: IPortfolioWithDetails[];
  modalTitle: EModalTitle;
}

export enum EParetoDealFilter {
  ALL = 'ALL',
  MINE = 'MINE',
}

export interface IParetoDeal {
  name: string;
  status: string;
  products: IParetoProduct[] | null;
}

export interface IParetoProduct {
  base: TNullableFloat;
  margin: TNullableFloat;
  monthlyVolume: TNullableFloat;
  name: string;
  netback: TNullableFloat;
  sales: TNullableFloat;
  totalVolume: TNullableFloat;
}

export interface IParetoProductWithDetails extends IParetoProduct {
  color: string;
  status: string;
  customer: string;
  dealName: string;
  regionProductLine: string;
  dateRange: string;
  dealId: string;
}

export interface IParetoInput {
  dealIDs: string[];
}

export interface IParetoOutput {
  errors: IErrorObject[] | null;
  result: IParetoDeal[] | null;
}
